<div style="height: min-content">
  <div class="modal-header lead fw-bold mt-2" translate>
    {{ 'GENERAL.GROUP_SELECTION.CUSTOMER_SELECTION.TITLE' | translate }}
    <button class="close-btn" (click)="closeIcon()">
      <kendo-svg-icon [icon]="icons.xIcon"></kendo-svg-icon>
    </button>
  </div>
  <div class="modal-body custom-shadow">
    <form [formGroup]="unitSearchForm" (submit)="loadAccessibleGroups(true)">
      <div class="d-flex flex-column flex-md-row gap-3 mb-2">
        @if (tenants?.length > 0) {
          <kendo-dropdownlist
            [data]="tenants"
            formControlName="tenantId"
            style="width: 15rem"
            [valuePrimitive]="true"
            valueField="displayName"
            textField="displayName">
          </kendo-dropdownlist>
        }
        <kendo-dropdownlist
          [data]="searchOptions"
          formControlName="option"
          [valuePrimitive]="true"
          valueField="key"
          textField="value"
          style="width: 15rem">
          <ng-template kendoDropDownListItemTemplate kendoDropDownListValueTemplate let-dataItem>
            <span>{{ dataItem?.value | translate }}</span>
          </ng-template>
        </kendo-dropdownlist>
        <kendo-textbox
          style="width: 15rem"
          placeholder="{{ 'GENERAL.GROUP_SELECTION.SEARCH_PLACEHOLDER' | translate }}"
          formControlName="term">
        </kendo-textbox>
        <button type="submit" style="width: 6rem" kendobutton class="button-modal btn-primary">
          {{ 'SHARED.SEARCH' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="modal-body ms-2">
    <kendo-grid
      class="custom-grid svg-icon"
      [data]="accessibleGroups | async"
      [pageSize]="state.take"
      [skip]="state.skip"
      [pageable]="isPagingRequired"
      [sortable]="true"
      [sort]="state.sort"
      (sortChange)="loadAccessibleGroups(false, $event)"
      [reorderable]="true"
      [resizable]="true"
      [loading]="isLoading"
      (dataStateChange)="state = $event"
      (pageChange)="loadAccessibleGroups(false)"
      [scrollable]="'none'">
      <kendo-grid-column field="displayName" [sortable]="false" title="Customer Name" [width]="50">
        <ng-template kendoGridHeaderTemplate>
          {{ 'GENERAL.GROUP_SELECTION.CUSTOMER_NAME' | translate }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="numberOfUnits"
        title="Units"
        [width]="30"
        [sortable]="{ initialDirection: 'desc' }">
        <ng-template kendoGridHeaderTemplate>
          {{ 'GENERAL.GROUP_SELECTION.UNITS' | translate }}
          <kendo-svg-icon
            [icon]="
              sortDirection()[0]?.dir === 'asc' ? icons.arrowUpIcon : icons.arrowDownIcon
            "></kendo-svg-icon>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column class="text-right" [width]="20">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span
            class="tke-link text-decoration-underline fw-bold"
            tabindex="0"
            (keydown.enter)="selectGroup(dataItem)"
            (click)="selectGroup(dataItem)">
            {{ 'GENERAL.GROUP_SELECTION.SHARED.SELECT' | translate }}
          </span>
        </ng-template>
      </kendo-grid-command-column>
      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
        <div class="d-flex justify-content-between align-items-center w-100 mt-2">
          <div class="kendo-pager-left d-flex color-tkDarkGray">
            <span class="show"> {{ 'SHARED.SHOWING' | translate }}</span>
            <kendo-pager-info></kendo-pager-info>
          </div>
          <div>
            @if (totalPages > 0 && currentPage > 1) {
              <button class="k-button k-button-icon" (click)="goToPreviousPage(currentPage)">
                <kendo-svg-icon [icon]="icons.chevronLeftIcon"></kendo-svg-icon>
              </button>
            }
            @for (page of getPageNumbers(totalPages, currentPage); track page) {
              <button
                class="k-button k-pager-nav"
                [ngClass]="{ 'k-selected': page === currentPage }"
                (click)="goToPage(page)">
                {{ page }}
              </button>
            }
            @if (currentPage < totalPages) {
              <button
                class="k-button k-button-icon"
                (click)="goToNextPage(currentPage, totalPages)">
                <kendo-svg-icon [icon]="icons.chevronRightIcon"></kendo-svg-icon>
              </button>
            }
          </div>
        </div>
      </ng-template>
    </kendo-grid>
  </div>
  @if (!isSearchActive) {
    <span class="modal-footer mb-2 ms-3">
      {{ 'GENERAL.GROUP_SELECTION.CUSTOMER_SELECTION.HINT' | translate }}
    </span>
  }
</div>
